export default __webpack_public_path__ + "static/media/Wall Outlet (BS1363).ac56988c.svg";